export const BRAND = "Kaliteli Hizmet, Daima Memnuniyet";
